import ResetState from "../ui-kit/resetstate";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
const CountSliderInput = ({
  value,
  onChange,
  className,
  step = 1,
  min = 0,
  max = 100,
  unit = "px",
  label = "",
  resetValue = 0,
}) => {
  value = value?.toString().replace(/\D/g, "");

  if (value === undefined || value === null) {
    value = resetValue;
  }
  const handleRangeValueChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className="text-grigora-base">
      <div className="text-ui-text-heading mb-2 flex flex-row justify-between items-center">
        {label}
        <ResetState
          active={value != resetValue}
          onClick={(e) => {
            onChange(resetValue);
          }}
        />
      </div>
      <div className=" flex justify-between gap-5">
        <div className="flex-1 flex items-center ">
          <input
            min={min}
            max={max}
            onChange={handleRangeValueChange}
            value={value}
            step={step}
            type="range"
            className="accent-ui-dark-blue
                border-0
                bg-ui-range
                appearance-none
                h-[5px] rounded-full
                w-full
                outline-none"
          />
        </div>
        <div className="flex p-2 w-16 px-3 bg-ui-light-white rounded-full ">
          <div className="flex">
            <input
              type="text"
              className="outline-none bg-ui-light-white w-full"
              value={value}
              onChange={handleRangeValueChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountSliderInput;
